import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const CreditsFAQ = () => {
  const faqs = [
    {
      question: "Do my credits renew?",
      answer: "STARTER credits are one-time and do not renew. CORE and PRO AI credits renew every month on your billing date. Addon credits never expire and are always used before your monthly credits."
    },
    {
      question: "What happens if I upgrade or switch plans?",
      answer: "Upgrading from Free to Core or Pro AI immediately unlocks the new plan and credit limits. Switching between Core and Pro AI updates your credits right away; the next monthly reset continues with the new plan's quantity."
    },
    {
      question: "What happens when I hit my limit?",
      answer: "You can still log tasks, projects, clients, and invoices normally. AI features (like smart ranking, recommendations, and voice capture) pause until your next monthly reset or until you add addon credits."
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container max-w-4xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            How Credits Work
          </h2>
          <p className="text-lg text-muted-foreground">
            Common questions about credit usage and renewals
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border border-border/50 rounded-lg bg-card px-6"
            >
              <AccordionTrigger className="text-left hover:no-underline">
                <span className="text-lg font-semibold">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="pt-2">
                <p className="text-base text-muted-foreground leading-relaxed">
                  {faq.answer}
                </p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default CreditsFAQ;
